import Carousel from 'shared/carousel/carousel'

const illustratedCardsCarousel = document.getElementById('illustratedCards-carousel')
if (illustratedCardsCarousel) {
	const carousel = new Carousel({
		element: illustratedCardsCarousel,
		itemsToScrollBy: 2
	})
	carousel.init()
}
